<template>
	<v-container>
		<PageTitle
		icon="mdi-shield-account"
		main="Area Reservada"
		sub="Geracao automatica e humanizada de pontos"
		/>

		<v-alert v-if="!isMaster" dense text type="info" class="mb-4">
			Esta area esta liberada somente para o seu cadastro.
		</v-alert>

		<v-card flat class="mb-4">
			<v-card-text class="pa-3">
				<v-row dense align="center">
					<v-col cols="12" md="4">
						<v-autocomplete
						v-model="filtros.idfuncionarios"
						:items="colaboradores"
						item-text="nome"
						item-value="idfuncionarios"
						label="Colaborador"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-account"
						:disabled="loading"
						/>
					</v-col>

					<v-col cols="12" sm="6" md="2">
						<v-select
						v-model="filtros.mes"
						:items="meses"
						item-text="nome"
						item-value="numero"
						label="Mes"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-calendar-month"
						:disabled="loading"
						/>
					</v-col>

					<v-col cols="12" sm="6" md="2">
						<v-select
						v-model="filtros.ano"
						:items="anos"
						label="Ano"
						outlined
						dense
						hide-details
						prepend-inner-icon="mdi-calendar"
						:disabled="loading"
						/>
					</v-col>

					<v-col cols="12" md="2">
						<v-switch
						v-model="filtros.sobrescrever"
						label="Sobrescrever"
						hide-details
						dense
						:disabled="loading"
						/>
					</v-col>

					<v-col cols="12" md="2" class="d-flex justify-end">
						<v-btn color="primary" :loading="loading" :disabled="isGerarDisabled" @click="confirmarGeracao">
							<v-icon left>mdi-auto-fix</v-icon>
							Gerar
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<v-alert dense outlined type="warning" class="mb-4">
			Por seguranca, dias com expediente existente sao pulados, exceto quando sobrescrever estiver ativo.
			Folgas e ferias cadastradas bloqueiam a geracao. No mes atual, gera somente ate ontem.
		</v-alert>

		<v-alert v-if="isPeriodoFuturo" dense outlined type="error" class="mb-4">
			Nao e permitido gerar pontos para mes futuro.
		</v-alert>

		<v-card v-if="isRegisteredMaster" flat class="mb-4 sensitive-card">
			<v-card-title class="d-flex align-center">
				<v-icon left color="error">mdi-shield-lock-outline</v-icon>
				<div>
					<div class="text-subtitle-1 font-weight-medium">Ajuste protegido do banco de horas</div>
					<div class="text-caption grey--text">Operacao excepcional com reautenticacao e auditoria imutavel.</div>
				</div>
			</v-card-title>
			<v-card-text>
				<v-alert dense outlined type="warning">
					Informe o saldo absoluto correto. O sistema calculara e registrara somente a diferenca.
				</v-alert>
				<v-row dense>
					<v-col cols="12" md="6">
						<v-autocomplete
							v-model="ajusteBanco.funcionarios_idfuncionarios"
							:items="saldosBanco"
							item-text="nome"
							item-value="idfuncionarios"
							label="Colaborador"
							outlined dense
							:disabled="ajustandoBanco"
							@change="onAdjustmentEmployeeChange"
						/>
					</v-col>
					<v-col cols="12" md="3">
						<v-text-field :value="minutosParaHora(saldoAtualAjuste)" label="Saldo atual" outlined dense readonly />
					</v-col>
					<v-col cols="12" md="3">
						<v-text-field
							v-model.trim="ajusteBanco.novoSaldo"
							label="Novo saldo"
							placeholder="05:30 ou -02:15"
							outlined dense
							:disabled="ajustandoBanco"
						/>
					</v-col>
					<v-col cols="12" md="3">
						<v-text-field v-model="ajusteBanco.data" label="Data efetiva" type="date" outlined dense :max="todayKey" :disabled="ajustandoBanco" />
					</v-col>
					<v-col cols="12" md="9">
						<v-textarea
							v-model.trim="ajusteBanco.motivo"
							label="Motivo detalhado"
							outlined dense rows="2" counter="255"
							:disabled="ajustandoBanco"
						/>
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field
							v-model="ajusteBanco.senhaConfirmacao"
							label="Confirme sua senha Master"
							type="password"
							autocomplete="current-password"
							outlined dense
							:disabled="ajustandoBanco"
						/>
					</v-col>
					<v-col cols="12" md="6" class="d-flex align-center">
						<v-checkbox
							v-model="ajusteBanco.confirmado"
							label="Conferi o colaborador, o saldo e a data efetiva."
							:disabled="ajustandoBanco"
						/>
					</v-col>
				</v-row>
				<v-alert v-if="erroAjusteBanco" dense text type="error">{{ erroAjusteBanco }}</v-alert>
				<div class="d-flex justify-end">
					<v-btn color="error" :loading="ajustandoBanco" :disabled="!ajusteBancoValido" @click="salvarAjusteBanco">
						<v-icon left>mdi-lock-check</v-icon>
						Confirmar ajuste protegido
					</v-btn>
				</div>
			</v-card-text>
		</v-card>

		<v-card v-if="isRegisteredMaster" flat class="mb-4">
			<v-card-title class="text-subtitle-1 font-weight-medium">Historico recente de ajustes protegidos</v-card-title>
			<v-data-table :headers="headersAjustes" :items="historicoAjustes" :items-per-page="10" dense>
				<template #item.data="{ item }">{{ formatDate(item.data) }}</template>
				<template #item.saldoAnteriorMinutos="{ item }">{{ minutosParaHora(item.saldoAnteriorMinutos) }}</template>
				<template #item.ajusteMinutos="{ item }">{{ minutosParaHora(item.ajusteMinutos) }}</template>
				<template #item.saldoFinalMinutos="{ item }">{{ minutosParaHora(item.saldoFinalMinutos) }}</template>
			</v-data-table>
		</v-card>

		<v-card v-if="resultado" flat>
			<v-card-title class="d-flex align-center">
				<v-icon left color="success">mdi-check-circle-outline</v-icon>
				<div>
					<div class="text-subtitle-1 font-weight-medium">Pontos gerados</div>
					<div class="text-caption grey--text">
						{{ resultado.colaborador.nome }} - {{ periodoLabel }}
					</div>
				</div>
			</v-card-title>

			<v-card-text>
				<v-row dense class="mb-4">
					<v-col cols="12" sm="6" md="3">
						<v-sheet outlined rounded class="metric pa-3">
							<div class="metric-label">Gerados</div>
							<div class="metric-value success--text">{{ resultado.gerados }}</div>
						</v-sheet>
					</v-col>

					<v-col cols="12" sm="6" md="3">
						<v-sheet outlined rounded class="metric pa-3">
							<div class="metric-label">Atualizados</div>
							<div class="metric-value primary--text">{{ resultado.atualizados || 0 }}</div>
						</v-sheet>
					</v-col>

					<v-col cols="12" sm="6" md="3">
						<v-sheet outlined rounded class="metric pa-3">
							<div class="metric-label">Pulados</div>
							<div class="metric-value grey--text text--darken-1">{{ resultado.pulados }}</div>
						</v-sheet>
					</v-col>

					<v-col cols="12" sm="6" md="3">
						<v-sheet outlined rounded class="metric pa-3">
							<div class="metric-label">Bloqueados</div>
							<div class="metric-value warning--text">{{ resultado.bloqueadosPorCalendario || 0 }}</div>
						</v-sheet>
					</v-col>

					<v-col cols="12" sm="6" md="3">
						<v-sheet outlined rounded class="metric pa-3">
							<div class="metric-label">Saldo gerado</div>
							<div class="metric-value" :class="resultado.saldoMinutos < 0 ? 'error--text' : 'success--text'">
								{{ minutosParaHora(resultado.saldoMinutos) }}
							</div>
						</v-sheet>
					</v-col>
				</v-row>

				<v-data-table
				:headers="headers"
				:items="resultado.registros"
				:items-per-page="31"
				dense
				class="reserved-table"
				no-data-text="Nenhum ponto gerado."
				/>
			</v-card-text>
		</v-card>

		<v-dialog v-model="dialogConfirmacao" max-width="520">
			<v-card>
				<v-card-title class="text-subtitle-1 font-weight-medium">
					Confirmar geracao automatica
				</v-card-title>
				<v-card-text>
					<div class="mb-2">
						Colaborador: <strong>{{ colaboradorSelecionadoNome }}</strong>
					</div>
					<div class="mb-2">
						Periodo: <strong>{{ periodoLabel }}</strong>
					</div>
					<div>
						Modo:
						<strong>{{ filtros.sobrescrever ? 'sobrescrever dias existentes' : 'pular dias existentes' }}</strong>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn text :disabled="loading" @click="dialogConfirmacao = false">Cancelar</v-btn>
					<v-btn color="primary" :loading="loading" @click="gerarPontos">Confirmar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import PageTitle from '@/templates/PageTitle'

const localDateKey = date => {
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')
	return `${year}-${month}-${day}`
}

const parseBalanceMinutes = value => {
	const match = String(value || '').trim().match(/^(-)?(\d+):([0-5]\d)$/)
	if (!match) return null
	const minutes = Number(match[2]) * 60 + Number(match[3])
	return match[1] ? -minutes : minutes
}

const newRequestId = () => {
	if (window.crypto?.randomUUID) return window.crypto.randomUUID()
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
		const random = Math.floor(Math.random() * 16)
		const value = char === 'x' ? random : (random & 0x3) | 0x8
		return value.toString(16)
	})
}

export default {
	name: 'AreaReservada',
	components: { PageTitle },
	data() {
		const now = new Date()
		const todayKey = localDateKey(now)
		return {
			loading: false,
			dialogConfirmacao: false,
			colaboradores: [],
			resultado: null,
			todayKey,
			saldosBanco: [],
			historicoAjustes: [],
			ajustandoBanco: false,
			erroAjusteBanco: '',
			ajusteBanco: {
				funcionarios_idfuncionarios: null,
				novoSaldo: '',
				data: todayKey,
				motivo: '',
				senhaConfirmacao: '',
				confirmado: false,
				requestId: newRequestId()
			},
			filtros: {
				idfuncionarios: null,
				mes: now.getMonth() + 1,
				ano: now.getFullYear(),
				sobrescrever: false
			},
			meses: [
				{ nome: 'Janeiro', numero: 1 },
				{ nome: 'Fevereiro', numero: 2 },
				{ nome: 'Marco', numero: 3 },
				{ nome: 'Abril', numero: 4 },
				{ nome: 'Maio', numero: 5 },
				{ nome: 'Junho', numero: 6 },
				{ nome: 'Julho', numero: 7 },
				{ nome: 'Agosto', numero: 8 },
				{ nome: 'Setembro', numero: 9 },
				{ nome: 'Outubro', numero: 10 },
				{ nome: 'Novembro', numero: 11 },
				{ nome: 'Dezembro', numero: 12 }
			],
			anos: Array.from({ length: 7 }, (_, i) => now.getFullYear() - i),
			headers: [
				{ text: 'Data', value: 'data', width: 110 },
				{ text: 'Entrada', value: 'entrada', align: 'center' },
				{ text: 'Saida almoco', value: 'saida_almoco', align: 'center' },
				{ text: 'Retorno', value: 'retorno', align: 'center' },
				{ text: 'Saida', value: 'saida', align: 'center' }
			],
			headersAjustes: [
				{ text: 'Data', value: 'data', width: 105 },
				{ text: 'Colaborador', value: 'colaborador' },
				{ text: 'Saldo anterior', value: 'saldoAnteriorMinutos', align: 'center' },
				{ text: 'Ajuste', value: 'ajusteMinutos', align: 'center' },
				{ text: 'Saldo final', value: 'saldoFinalMinutos', align: 'center' },
				{ text: 'Autor', value: 'autor' },
				{ text: 'Motivo', value: 'motivo' }
			]
		}
	},
	computed: {
		...mapState(['user']),
		isMaster() {
			return String(this.user?.tipo || '').trim().toLowerCase() === 'master'
		},
		isRegisteredMaster() {
			return this.isMaster && Number(this.user?.id) > 0
		},
		saldoAtualAjuste() {
			const selected = this.saldosBanco.find(item => item.idfuncionarios === this.ajusteBanco.funcionarios_idfuncionarios)
			return Number(selected?.saldoMinutos || 0)
		},
		ajusteBancoValido() {
			return !!this.ajusteBanco.funcionarios_idfuncionarios &&
				parseBalanceMinutes(this.ajusteBanco.novoSaldo) !== null &&
				!!this.ajusteBanco.data && this.ajusteBanco.data <= this.todayKey &&
				this.ajusteBanco.motivo.length >= 10 && this.ajusteBanco.motivo.length <= 255 &&
				!!this.ajusteBanco.senhaConfirmacao && this.ajusteBanco.confirmado && !this.ajustandoBanco
		},
		isGerarDisabled() {
			return !this.filtros.idfuncionarios || !this.filtros.mes || !this.filtros.ano || this.isPeriodoFuturo
		},
		isPeriodoFuturo() {
			const now = new Date()
			const anoAtual = now.getFullYear()
			const mesAtual = now.getMonth() + 1
			return this.filtros.ano > anoAtual || (this.filtros.ano === anoAtual && this.filtros.mes > mesAtual)
		},
		periodoLabel() {
			const mes = this.meses.find(item => item.numero === this.filtros.mes)
			return `${mes?.nome || this.filtros.mes}/${this.filtros.ano}`
		},
		colaboradorSelecionadoNome() {
			const colaborador = this.colaboradores.find(item => item.idfuncionarios === this.filtros.idfuncionarios)
			return colaborador?.nome || '-'
		}
	},
	methods: {
		async loadSensitiveAdjustmentData() {
			if (!this.isRegisteredMaster) return
			try {
				const [balances, history] = await Promise.all([
					axios.get(`${baseApiUrl}/area-reservada/banco-horas/saldos`),
					axios.get(`${baseApiUrl}/area-reservada/banco-horas/ajustes`)
				])
				this.saldosBanco = balances.data || []
				this.historicoAjustes = history.data || []
				if (!this.ajusteBanco.funcionarios_idfuncionarios && this.saldosBanco.length) {
					this.ajusteBanco.funcionarios_idfuncionarios = this.saldosBanco[0].idfuncionarios
					this.onAdjustmentEmployeeChange()
				}
			} catch (error) {
				showError(error)
			}
		},
		onAdjustmentEmployeeChange() {
			this.ajusteBanco.novoSaldo = this.minutosParaHora(this.saldoAtualAjuste)
			this.ajusteBanco.confirmado = false
			this.ajusteBanco.senhaConfirmacao = ''
			this.ajusteBanco.requestId = newRequestId()
			this.erroAjusteBanco = ''
		},
		async salvarAjusteBanco() {
			if (!this.ajusteBancoValido) return
			this.ajustandoBanco = true
			this.erroAjusteBanco = ''
			try {
				await axios.post(`${baseApiUrl}/area-reservada/banco-horas/ajustes`, {
					funcionarios_idfuncionarios: this.ajusteBanco.funcionarios_idfuncionarios,
					saldoMinutos: parseBalanceMinutes(this.ajusteBanco.novoSaldo),
					saldoAtualEsperadoMinutos: this.saldoAtualAjuste,
					data: this.ajusteBanco.data,
					motivo: this.ajusteBanco.motivo,
					senhaConfirmacao: this.ajusteBanco.senhaConfirmacao,
					requestId: this.ajusteBanco.requestId
				})
				this.$toasted.success('Ajuste protegido registrado com sucesso.')
				this.ajusteBanco.motivo = ''
				this.ajusteBanco.senhaConfirmacao = ''
				this.ajusteBanco.confirmado = false
				this.ajusteBanco.requestId = newRequestId()
				await this.loadSensitiveAdjustmentData()
				this.onAdjustmentEmployeeChange()
			} catch (error) {
				this.erroAjusteBanco = error?.response?.data || 'Nao foi possivel registrar o ajuste.'
				if (error?.response?.status === 409) {
					await this.loadSensitiveAdjustmentData()
					this.onAdjustmentEmployeeChange()
				}
			} finally {
				this.ajustandoBanco = false
			}
		},
		formatDate(value) {
			if (!value) return '-'
			const [year, month, day] = String(value).slice(0, 10).split('-')
			return `${day}/${month}/${year}`
		},
		async loadColaboradores() {
			this.loading = true
			try {
				const { data } = await axios.get(`${baseApiUrl}/area-reservada/colaboradores`)
				this.colaboradores = Array.isArray(data) ? data : []

				if (!this.filtros.idfuncionarios && this.colaboradores.length) {
					this.filtros.idfuncionarios = this.colaboradores[0].idfuncionarios
				}
			} catch (error) {
				showError(error)
			} finally {
				this.loading = false
			}
		},
		confirmarGeracao() {
			if (this.isGerarDisabled) return
			this.dialogConfirmacao = true
		},
		async gerarPontos() {
			this.loading = true
			try {
				const payload = {
					idfuncionarios: this.filtros.idfuncionarios,
					mes: this.filtros.mes,
					ano: this.filtros.ano,
					sobrescrever: this.filtros.sobrescrever
				}
				const { data } = await axios.post(`${baseApiUrl}/area-reservada/gerar-pontos`, payload)
				this.resultado = data
				this.dialogConfirmacao = false
			} catch (error) {
				showError(error)
			} finally {
				this.loading = false
			}
		},
		minutosParaHora(totalMinutos) {
			const total = Number(totalMinutos || 0)
			const sinal = total < 0 ? '-' : ''
			const abs = Math.abs(total)
			const horas = Math.floor(abs / 60)
			const minutos = abs % 60
			return `${sinal}${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`
		}
	},
	mounted() {
		this.loadColaboradores()
		this.loadSensitiveAdjustmentData()
	}
}
</script>

<style scoped>
.metric {
	border-radius: 4px;
}

.metric-label {
	color: #757575;
	font-size: 0.78rem;
	line-height: 1.1;
}

.metric-value {
	font-size: 1.2rem;
	font-weight: 700;
	margin-top: 4px;
	font-variant-numeric: tabular-nums;
}

.reserved-table {
	border: 1px solid #e0e0e0;
	border-radius: 4px;
}

.sensitive-card {
	border: 1px solid #ef9a9a;
}
</style>
